const joyrideReducer = (state, action) => {
  switch (action.type) {
    case 'SET_ACTIVE':
      return {
        ...state,
        tourActive: action.payload
      }
    case 'SET_RUN':
      return {
        ...state,
        run: action.payload
      }
    case 'SET_STEP_INDEX':
      return {
        ...state,
        stepIndex: action.payload
      }
    case 'INC_STEP_INDEX':
      return {
        ...state,
        stepIndex: state.stepIndex++
      }
    case 'DEC_STEP_INDEX':
      return {
        ...state,
        stepIndex: --state.stepIndex
      }
    case 'SET_TOUR_TYPE':
      return {
        ...state,
        steps: action.steps,
        callBack: action.callback
      }
    default:
      return state
  }
}

export default joyrideReducer
